<template>
  <div class="app">
    <router-view />
    <vue-snotify />
    <login v-if="!$root.$store.state.user" />
  </div>
</template>

<script>
import Login from '@/components/Login'

export default {
  name: 'App',
  components: {
    Login
  },
  mounted () {
    window.addEventListener('keydown', (e) => {
      if (e.key === 'F7') {
        const locs = this.$i18n.availableLocales
        let next = locs.indexOf(this.$i18n.locale) + 1
        if (next >= locs.length) {
          next = 0
        }
        this.$store.dispatch('setUiLocale', { locale: locs[next] })
      }
    })
  }
}
</script>

<style lang="scss">
@import './_font';
@import '~vue-snotify/styles/simple';
@import './_snotifyCustomization';

*,
*::before,
*::after {
  box-sizing: inherit;
  outline: 0;
}

html {
  box-sizing: border-box;
  outline: 0;
}

html, body {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  font-family: 'Ubuntu', sans-serif;
  font-weight: 300;
  text-rendering: optimizeLegibility;
  -moz-font-smoothing: antialiased;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #fff;
  overflow: hidden;
}

.editor {
  font-family: 'Ubuntu', sans-serif !important;
}

a {
  text-decoration: none;
  color: inherit;
}

.scroll-y {
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    -webkit-border-radius: 8px;
    border-radius: 8px;
    background: rgba(0, 0, 0, 0.4);
  }

  &.no-scrollbar::-webkit-scrollbar {
    display: none;
  }
}
</style>
